var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightTenantEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 333,
    viewBox: "0 0 166 333",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.529 166.63C145.529 247.032 80.3683 312.202 -0.00161743 312.202C-80.3715 312.202 -145.533 247.032 -145.533 166.63C-145.533 86.2285 -80.3715 21.0586 -0.00161743 21.0586C80.3683 21.0586 145.529 86.2285 145.529 166.63Z",
    stroke: "#F5F5F5",
    strokeWidth: 40.7393
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightTenantEllipse);
export default __webpack_public_path__ + "static/media/right-tenant-ellipse.2dadc49722f2248964253d70e1771bc9.svg";
export { ForwardRef as ReactComponent };